<template>
  <div class="mi-site mi-site--lock">
    <a class="mi-skip" href="#main">Skip to content</a>
    <MarketingHeader />

    <main id="main">
      <section class="mi-hero">
        <div class="mi-hero-atmosphere" aria-hidden="true">
          <span class="mi-hero-orb mi-hero-orb-a"></span>
          <span class="mi-hero-orb mi-hero-orb-b"></span>
          <span class="mi-hero-orb mi-hero-orb-c"></span>
        </div>

        <div class="mi-hero-listings" aria-hidden="true">
          <article
            v-for="card in listings"
            :key="card.id"
            class="mi-listing"
            :class="'mi-listing--' + card.slot"
          >
            <div class="mi-listing-media">
              <img
                v-for="(src, i) in card.photos"
                :key="src"
                :src="src"
                alt=""
                :class="{ 'is-on': i === card.photoIndex }"
              />
              <span v-if="card.badge" class="mi-listing-chip">{{ card.badge }}</span>
              <span v-if="card.photos.length > 1" class="mi-listing-dots">
                <i
                  v-for="(src, i) in card.photos"
                  :key="'d-' + src"
                  :class="{ 'is-on': i === card.photoIndex }"
                />
              </span>
            </div>
            <div class="mi-listing-body">
              <p class="mi-listing-price">
                <s v-if="card.wasPrice">{{ card.wasPrice }}</s>
                {{ card.price }}
              </p>
              <p class="mi-listing-addr">{{ card.address }}</p>
              <p class="mi-listing-meta">{{ card.meta }}</p>
            </div>
          </article>
        </div>

        <div class="mi-shell mi-hero-copy">
          <p class="mi-hero-mark">MLS Ingest</p>
          <h1>The <span class="mi-grad">AI infrastructure</span> behind real estate search.</h1>
          <p class="mi-lede">
            MLS Ingest is the underlying MLS data layer that can power search and other real estate technology.
          </p>

          <div class="mi-hero-actions">
            <router-link to="/contact" class="mi-btn mi-btn--sales">Contact sales</router-link>
            <p class="mi-hero-note">
              MLS Ingest is now a Brokurz company.
              <router-link to="/announcement">Read the announcement</router-link>
            </p>
          </div>
        </div>
      </section>
    </main>

    <MarketingFooter />
  </div>
</template>

<script>
import MarketingHeader from './MarketingHeader'
import MarketingFooter from './MarketingFooter'
import '../assets/marketing.css'

export default {
  name: 'MarketingPage',
  components: { MarketingHeader, MarketingFooter },
  data() {
    return {
      timers: [],
      listings: [
        {
          id: 'tl',
          slot: 'tl',
          photos: ['/hero-listings/01.jpg', '/hero-listings/07.jpg', '/hero-listings/08.jpg'],
          photoIndex: 0,
          photoMs: 7200,
          price: '$12,400,000',
          wasPrice: null,
          badge: null,
          status: null,
          address: '128 Seaview Drive, Malibu',
          meta: '6 BD  ·  7 BA  ·  8,120 SF',
        },
        {
          id: 'tr',
          slot: 'tr',
          photos: ['/hero-listings/02.jpg', '/hero-listings/09.jpg', '/hero-listings/10.jpg'],
          photoIndex: 0,
          photoMs: 8500,
          price: '$8,750,000',
          reduceTo: '$7,950,000',
          reduceAt: 4200,
          wasPrice: null,
          badge: null,
          status: null,
          address: '44 Mercer Street, New York',
          meta: '3 BD  ·  3 BA  ·  4,180 SF',
        },
        {
          id: 'ml',
          slot: 'ml',
          photos: ['/hero-listings/03.jpg', '/hero-listings/11.jpg', '/hero-listings/12.jpg'],
          photoIndex: 0,
          photoMs: 7800,
          price: '$6,200,000',
          wasPrice: null,
          badge: 'Just listed',
          status: null,
          address: '901 Turtle Creek, Dallas',
          meta: '5 BD  ·  6 BA  ·  7,040 SF',
        },
        {
          id: 'mr',
          slot: 'mr',
          photos: ['/hero-listings/04.jpg', '/hero-listings/13.jpg', '/hero-listings/14.jpg'],
          photoIndex: 0,
          photoMs: 9200,
          price: '$4,875,000',
          wasPrice: null,
          badge: 'Open Sun 1–4',
          status: null,
          address: '17 Pacific Coast, Newport',
          meta: '4 BD  ·  5 BA  ·  4,860 SF',
        },
        {
          id: 'bl',
          slot: 'bl',
          photos: ['/hero-listings/05.jpg', '/hero-listings/15.jpg', '/hero-listings/16.jpg'],
          photoIndex: 0,
          photoMs: 6800,
          price: '$9,450,000',
          wasPrice: null,
          badge: null,
          status: null,
          address: '880 Mayfair Road, Los Angeles',
          meta: '5 BD  ·  5 BA  ·  6,380 SF',
        },
        {
          id: 'br',
          slot: 'br',
          photos: ['/hero-listings/06.jpg', '/hero-listings/17.jpg', '/hero-listings/18.jpg'],
          photoIndex: 0,
          photoMs: 8800,
          price: '$18,900,000',
          wasPrice: null,
          badge: null,
          status: null,
          address: '210 Ocean Boulevard, Palm Beach',
          meta: '7 BD  ·  8 BA  ·  11,200 SF',
        },
      ],
    }
  },
  mounted() {
    const quiet = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (quiet) {
      this.listings.forEach((card, i) => {
        if (card.reduceTo) {
          this.$set(this.listings, i, {
            ...card,
            wasPrice: card.price,
            price: card.reduceTo,
            badge: 'Price reduced',
          })
        }
      })
      return
    }

    this.listings.forEach((card, i) => {
      if (card.photos.length > 1) {
        this.timers.push(
          setInterval(() => {
            const row = this.listings[i]
            this.$set(row, 'photoIndex', (row.photoIndex + 1) % row.photos.length)
          }, card.photoMs || 3400)
        )
      }
      if (card.reduceTo) {
        this.timers.push(
          setTimeout(() => {
            const row = this.listings[i]
            this.$set(row, 'wasPrice', row.price)
            this.$set(row, 'price', card.reduceTo)
            this.$set(row, 'badge', 'Price reduced')
          }, card.reduceAt)
        )
      }
    })
  },
  beforeDestroy() {
    this.timers.forEach((id) => {
      clearInterval(id)
      clearTimeout(id)
    })
  },
}
</script>
